import UserService from "@/services/user.service";

export const user = {
    namespaced: true,
    state: {me: null, employees: [], error: null, markerTemplate: null, fakeData: false},
    actions: {
        me({commit}) {
            return UserService.me()
                .then(
                    me => {
                        commit('fetchMe', me)
                    },
                    error => {
                        commit('fetchingFail', error)
                    }
                )
        },
        getData({commit}, data) {
            return UserService.getData(data)
                .then(
                    user => {
                        commit('fetchUser', user)
                    },
                    error => {
                        commit('fetchingFail', error)
                    }
                )
        },
        getPermissions({commit}, data) {
            return UserService.getPermissions(data)
                .then(
                    permissions => {
                        commit('fetchPermissions', permissions)
                    },
                    error => {
                        commit('fetchingFail', error)
                    }
                )
        },
        update({commit}, data) {
            return UserService.update(data).then(
                me => {
                    if (!me.data.success) {
                        commit('fetchingFail', me.data.message)
                    } else {
                        commit('fetchMe', me)
                    }
                },
                error => {
                    commit('fetchingFail', error)
                }
            )
        },
        users({commit}) {
            return UserService.users().then(
                employees => {
                    commit('fetchUsers', employees)
                },
                error => {
                    commit('fetchingFail', error)
                }
            )
        },
        getMarkerTemplate({commit}) {
            return UserService.getMarkerTemplate().then(
                marker => {
                    commit('markerSuccessFetch', marker)
                },
                error => {
                    commit('fetchingFail', error)
                }
            )
        },
        updateMarkerTemplate({commit}, data) {
            return UserService.updateMarkerTemplate(data).then(
                marker => {
                    commit('markerSuccessFetch', marker)
                },
                error => {
                    commit('fetchingFail', error)
                }
            )
        },
        toggleFakeData({commit}) {
            return UserService.toggleFakeData().then(
                data => {
                    commit('fakeData', data)
                },
                error => {
                    commit('fetchingFail', error)
                }
            )
        },
        getFakeDataEnabled({commit}) {
            return UserService.getFakeDataEnabled().then(
                data => {
                    commit('fakeData', data)
                },
                error => {
                    commit('fetchingFail', error)
                }
            )
        }
    },
    mutations: {
        fetchMe(state, me) {
            state.me = me
        },
        fetchUser(state, employee) {
            employee = employee.data
            state.employee = employee
        },
        fetchPermissions(state, permissions) {
            permissions = permissions.data
            state.permissions = permissions
        },
        fetchUsers(state, employees) {
            state.employees = employees
        },
        fetchingFail(state, error) {
            state.error = error
        },
        markerSuccessFetch(state, marker) {
            state.markerTemplate = JSON.parse(marker.data.marker.jsonb_value)
        },
        fakeData(state, data) {
            state.fakeData = data.data.fakeData
        }
    }
}